import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import SubscriberListChild from "./SubscriberListChild";

const SubscriberList = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <SubscriberListChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default SubscriberList;
